import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchDeal = createAsyncThunk(
  'deal/fetch',
  async (uuid, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: `/api/billing/deals/${uuid}`,
      method: 'GET'
    })

    if (!success) {
      if (response?.message) {
        return rejectWithValue(response.payload)
      }

      return rejectWithValue(true)
    }

    return {
      ...response,
      uuid
    }
  }
)
